import { FC, PropsWithChildren, useMemo, useState } from "react";
import { StepFourFormContext } from "./StepFourFormContext";
import { useForm } from "antd/es/form/Form";
import { CreditCardsInsured } from "../../../../../../../../shared/interfaces";
import { TransferRightsFormData } from "../../../../../../../../shared/interfaces/services/transfer-rights-service";

export interface ClientDataSectionForm {
  documentType: number;
  documentNumber: number;
  cuit: number;
  fullName: string;
  genderType: number;
  nationality: number;
  province: string;
  location: string;
  address: string;
  ivaCondition: number;
  perceptionAgent: string;
  personType: string;
  societyType: number;
  inscriptionDate: any;
  inscriptionNumber: string;
  contractDate: any;
}

export interface AdditionalDataSectionForm {
  telephoneNumber: string;
  telephoneNumberJob: string;
  cellphoneNumber: string;
  webPage: string;
  birthDate: string;
  placeOfBirth: string;
  countryBirth: number;
  profession: number;
  civilStatus: number;
  cuilNumber: number;
  economicActivity: number;
  addressEmail: string;
  rutaNumber: number;
}

export interface PaymentMethodSectionForm {
  paymentMethod: string;
  cbuNumber: number;
  cardNumber: number;
  companyCreditCard: number;
  expiration: string;
}

export const StepFourFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const [additionalDataSectionForm] = useForm<AdditionalDataSectionForm>();
  const [paymentMethodSectionForm] = useForm<PaymentMethodSectionForm>();
  const [propertyDataForm] = useForm();
  const [validitySectionForm] = useForm<{ validityDate: any }>();

  const [additionalDataFormValues, setAdditionalDataFormValues] =
    useState<AdditionalDataSectionForm>();

  const [errorCreditCardMessage, setErrorCreditCardMessage] =
    useState<string>('');

  const [listCreditCardInsured, setListCreditCardInsured] =
    useState<CreditCardsInsured>();
  const [methodSelectedFromStepThree, setMethodSelectedFromStepThree] =
    useState<any>();

  const [paymentMethodFormValues, setPaymentMethodFormValues] =
    useState<PaymentMethodSectionForm>();

  const [transferRightsList, setTransferRightsList] = useState<TransferRightsFormData[]>([]);

  const values = useMemo(
    () => ({
      additionalDataFormValues,
      additionalDataSectionForm,
      errorCreditCardMessage,
      listCreditCardInsured,
      methodSelectedFromStepThree,
      paymentMethodFormValues,
      paymentMethodSectionForm,
      propertyDataForm,
      setAdditionalDataFormValues,
      setErrorCreditCardMessage,
      setListCreditCardInsured,
      setMethodSelectedFromStepThree,
      setPaymentMethodFormValues,
      setTransferRightsList,
      transferRightsList,
      validitySectionForm,
    }),
    [
      additionalDataFormValues,
      additionalDataSectionForm,
      errorCreditCardMessage,
      listCreditCardInsured,
      methodSelectedFromStepThree,
      paymentMethodFormValues,
      paymentMethodSectionForm,
      propertyDataForm,
      setAdditionalDataFormValues,
      setErrorCreditCardMessage,
      setListCreditCardInsured,
      setMethodSelectedFromStepThree,
      setPaymentMethodFormValues,
      setTransferRightsList,
      transferRightsList,
      validitySectionForm,
    ]
  );

  return (
    <StepFourFormContext.Provider value={values}>
      {children}
    </StepFourFormContext.Provider>
  );
};